import React, { useEffect, useState } from 'react'
import CommentIcon from '@mui/icons-material/Comment';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import WarningIcon from '@mui/icons-material/Warning';
import driverImage from '../../../../../assets/images/no-image.png'

export const DriverResource = (props) => {
    const { resource, toggleOpenMail,openMail,handleDragStart } = props
    const [driver,setDriver] = useState({})
    let driverName = ""
    useEffect(()=>{        
        if(resource?.drivers?.length >0){
            setDriver(resource.drivers[0])
            driverName = resource.drivers[0].firstName + ' '+resource.drivers[0].lastName
        }
    },[resource])
    return (
        <div className='d-flex mt8'>
            <div className='driver-logo'>
                <div className='d-flex cursor-pointer relative'>
                    <div style={{ backgroundColor: '#e3f0f8', marginRight: '10px', borderRadius: '5px' }}>
                        {/* {resource?.firstName && <img src={driverImage} style={{ borderRadius: '4px', height: '50px', verticalAlign: 'middle', }} alt="user" />} */}
                        {<img src={driverImage} style={{ borderRadius: '4px', height: '50px', verticalAlign: 'middle',pointerEvents:'none' }} alt="user" />}
                    </div>
                    {/* <span style={{ fontWeight: '600', display: 'flex', alignItems: 'center', minWidth: '98px' }}>{resource?.firstName?.replace('-', ' ') + " "+resource?.lastName?.replace('-', ' ')} </span> */}
                    <span style={{ fontWeight: '600', display: 'flex', alignItems: 'center', minWidth: '98px' }} 
                        draggable onDragStart={e => handleDragStart(e, "Resource",resource)}
                        >{`${driver?.firstName || ''} ${driver?.lastName || ''}`} </span>
                </div>
            </div>
            <div style={{ margin: "0 5px", display: 'flex', gap: 3, alignItems: 'center' }} >
                {/* <i className="icon" style={{ height: '20px' }} >
                    {openMail.resource == resource.name && openMail.isOpened ? <CommentIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: false })} /> : <MarkUnreadChatAltIcon color='primary' fontSize="small" onClick={e => toggleOpenMail({ resource: resource.name, isOpened: true })} />}
                </i>
                <WarningIcon color='warning' fontSize="small" /> */}
            </div>
        </div>
  )
}
